module.exports = __webpack_public_path__ + "static/media/wrong.383b8a66.png";